<template>
  <div
    ref="filterWrapperRef"
    class="relative flex flex-wrap items-center rounded-[12px] p-5 text-[18px] shadow-drop-2 md:flex-nowrap lg:px-[36px] lg:py-[32px]"
  >
    <BaseTheDropdownSelect
      v-if="getDropdownFormattedData(centuriesList).length"
      class="mr-5 max-w-[40%] md:max-w-[initial] lg:mr-[20px] xl:mr-[30px] 2xl:mr-[60px]"
      :initial-select-value="selectedCentury"
      :placeholder="romeCenturies[selectedCenturyId]"
      :list="getDropdownFormattedData(centuriesList)"
      @on-select="selectedCenturyId = $event"
    />
    <BaseTheDropdownSelect
      v-if="getDropdownFormattedData(rubricsList).length"
      class="mr-5 max-w-[40%] md:max-w-[initial] lg:mr-[20px] xl:mr-[30px] 2xl:mr-[60px]"
      :initial-select-value="+selectedCategory"
      :placeholder="rubricPlaceholder"
      :list="getDropdownFormattedData(rubricsList)"
      @on-select="selectedCategoryId = $event"
    />
    <BaseTheDropdownSelect
      v-if="getDropdownFormattedData(sortOptions).length"
      class="max-w-[40%] md:mr-8 md:max-w-[initial] lg:mr-[20px] xl:mr-[30px] 2xl:mr-[60px]"
      :initial-select-value="+selectedSortOption"
      :placeholder="sortPlaceholder"
      :list="getDropdownFormattedData(sortOptions)"
      @on-select="selectedSortOptionId = $event"
    />
    <BaseTheDropdownSelect
      v-if="getDropdownFormattedData(filterOptions).length"
      class="max-w-[40%] md:mr-8 md:max-w-[initial] lg:mr-[20px] xl:mr-[30px] 2xl:mr-[60px]"
      :initial-select-value="+selectedFilterOption"
      :placeholder="filterPlaceholder"
      :list="getDropdownFormattedData(filterOptions)"
      @on-select="selectedFilterOptionId = $event"
    />
    <BaseTheDropdownSelect
      v-if="getDropdownFormattedData(sourcesList).length"
      class="max-w-[40%] md:mr-8 md:max-w-[initial] lg:mr-[20px] xl:mr-[30px] 2xl:mr-[60px]"
      :initial-select-value="+selectedSourceOption"
      placeholder="Источник"
      :list="getDropdownFormattedData(sourcesList)"
      @on-select="selectedSourceOptionId = $event"
    />
    <BaseTheDropdownSelect
      v-if="getDropdownFormattedData(cityOptions).length"
      class="max-w-[40%] md:max-w-[initial] lg:mr-[20px] xl:mr-[30px] 2xl:mr-[60px]"
      placeholder="Город"
      :list="getDropdownFormattedData(cityOptions)"
      @on-select="selectedCityId = $event"
    />
    <div
      v-if="!isCenturiesDisabled && !isTimeline"
      class="order-4 mt-4 flex w-full max-w-[524px] flex-wrap items-center justify-between border-t border-[#F3F3F3] pt-4 md:order-none md:mr-8 md:mt-[initial] md:flex-nowrap md:justify-start md:whitespace-nowrap md:border-none md:pt-[initial] xl:min-w-[335px] 2xl:min-w-[375px]"
    >
      <span class="mb-2 w-2/5 md:mb-[initial] md:w-[initial]">
        {{ romeCenturies[getCenturyByIndex(startIndex)] }}
      </span>
      <TimeLineCenturiesSlider
        :key="`${resetCount}`"
        class="order-3 w-full pl-[14px] pr-1 md:order-none md:px-9"
        :start-century="startIndex"
        :end-century="endIndex"
        @on-century-change="handleCenturySlider"
      />
      <span
        class="order-2 w-2/5 text-right md:order-none md:w-[initial] md:text-left"
      >
        {{ romeCenturies[getCenturyByIndex(endIndex)] }}
      </span>
    </div>
    <div
      v-if="!isCenturiesDisabled && isTimeline"
      class="order-4 mt-4 flex w-full max-w-[524px] flex-wrap items-start justify-between border-t border-[#F3F3F3] pt-4 md:order-none md:mr-8 md:mt-[initial] md:flex-nowrap md:justify-start md:whitespace-nowrap md:border-none md:pt-[initial] xl:min-w-[335px] 2xl:min-w-[375px]"
    >
      <span class="mb-2 w-2/5 md:mb-[initial] md:w-[initial]">
        {{ query.start_year }}
      </span>
      <!-- :key="`${query.start_year}`" -->
      <TimeLineCenturiesSlider
        v-if="query.start_year > 0"
        class="order-3 w-full pl-[14px] pr-1 md:order-none md:px-9"
        is-timeline
        :value="query"
        @on-century-change="handleYearsSliderInteract"
      />
      <span
        class="order-2 w-2/5 text-right md:order-none md:w-[initial] md:text-left"
      >
        {{ query.end_year }}
      </span>
    </div>
    <button
      v-if="isAnyFiltersActive"
      class="order-3 ml-auto flex items-center text-collection md:order-none"
      @click="handleResetFilters()"
    >
      <span class="hidden whitespace-nowrap xl:block">Сбросить фильтры</span>
      <SvgIcon name="close" class="md:ml-8 lg:ml-[4px] xl:mt-[2px]" />
    </button>
  </div>
</template>

<script setup>
import { debounce } from '@/services/helpers';
const props = defineProps({
  rubricsList: {
    type: Array,
    default: () => [],
  },

  rubricPlaceholder: {
    type: String,
    default: 'Рубрика',
  },

  defaultCategory: {
    type: Number,
    default: 0,
  },

  filterPlaceholder: {
    type: String,
    default: 'Рубрика',
  },

  sortPlaceholder: {
    type: String,
    default: 'Сортировать',
  },

  filtersActive: {
    type: Object,
    default: () => ({}),
  },

  centuriesList: {
    type: Array,
    default: () => [],
  },

  filterOptions: {
    type: Array,
    default: () => [],
  },

  sourcesList: {
    type: Array,
    default: () => [],
  },

  isCenturiesDisabled: {
    type: Boolean,
    default: false,
  },

  isInitialValue: {
    type: Number,
    default: 0,
  },

  isTimeline: {
    type: Boolean,
    default: false,
  },

  // isBiography: {
  //   type: Boolean,
  //   default: false,
  // },

  // categorySelectedSearch: {
  //   type: Number,
  //   default: 1,
  // },

  sortOptions: {
    type: Array,
    default: () => [],
  },

  cityOptions: {
    type: Array,
    default: () => [],
  },

  isNotArrayCentury: {
    type: Boolean,
    default: false,
  },

  preservedQuery: {
    type: Array,
    default: () => [],
  },
});

const route = useRoute();
const router = useRouter();
const emit = defineEmits([
  'on-century-change',
  'on-apply',
  'on-sort-change',
  'on-city-change',
  'on-century-start-change',
  'on-century-end-change',
  'on-reset-filters',
  'on-source-change',
  'on-filter-change',
]);

const selectedCategoryId = ref(0);
const selectedCenturyId = ref(0);
const startCenturyIndex = ref(0);
const endCenturyIndex = ref(0);
const selectedSortOptionId = ref(0);
const selectedSourceOptionId = ref(0);
const selectedFilterOptionId = ref(0);
const selectedCityId = ref(0);
const width = ref(0);
const resetCount = ref(0);
const filterWrapperRef = ref(null);

const romeCenturies = {
  9: 'IX век',
  10: 'X век',
  11: 'XI век',
  12: 'XII век',
  13: 'XIII век',
  14: 'XIV век',
  15: 'XV век',
  16: 'XVI век',
  17: 'XVII век',
  18: 'XVIII век',
  19: 'XIX век',
  20: 'XX век',
  21: 'XXI век',
};

/** computed */
const startIndex = computed(() => {
  return props.filtersActive?.startCentury ?? 9;
});

const endIndex = computed(() => {
  return props.filtersActive?.endCentury ?? 21;
});

const selectedCentury = computed(() => {
  const century = props.filtersActive?.century ?? props.isInitialValue;
  return Number(century);
});

const selectedCategory = computed(() => {
  return props.filtersActive?.category ?? props.defaultCategory;
});

const selectedSortOption = computed(() => {
  return (
    props.sortOptions.find((el) => el.value === props.filtersActive?.sort_by)
      ?.id ?? 0
  );
});

const selectedFilterOption = computed(() => {
  return (
    props.filterOptions.find((el) => el.value === props.filtersActive?.type)
      ?.id ?? 0
  );
});

const selectedSourceOption = computed(() => {
  return (
    props.sourcesList.find((el) => el.id === +props.filtersActive?.source)
      ?.id ?? 0
  );
});

const query = computed(() => {
  const defaultStartYear = (selectedCentury.value - 1) * 100 + 1;
  const defaultEndYear = selectedCentury.value * 100;
  const start = route.query?.start_year ?? defaultStartYear;
  const end = route.query?.end_year ?? defaultEndYear;

  return {
    start_year: Number(start),
    end_year: Number(end),
    range_start: defaultStartYear,
    range_end: defaultEndYear,
  };
});

const isAnyFiltersActive = computed(() => {
  return Object.values(props.filtersActive).filter((filter) => !!filter).length;
});

/** onMounted */
onMounted(() => {
  width.value = filterWrapperRef.value.getBoundingClientRect().width;
});

/** watch */
watch(selectedCenturyId, async (val) => {
  if (!val) return;
  const payload = props.isNotArrayCentury
    ? val
    : [(val - 1) * 100 + 1, val * 100];
  await router
    .replace({
      path: route.path,
      query: {
        ...route.query,
        ...(!props.isTimeline && payload && { century: payload }),
        ...(props.isTimeline &&
          payload && {
            century: val,
            start_year: payload[0],
            end_year: payload[1],
          }),
      },
    })
    .catch(() => {});
});

watch(selectedCategoryId, async (val) => {
  await router.replace({
    path: route.path,
    query: {
      ...route.query,
      ...(val && { category: val }),
    },
  });
});

watch(selectedSortOptionId, async (val) => {
  let selectedSortValue;
  if (val === 0) {
    selectedSortValue = undefined;
  } else {
    selectedSortValue =
      props.sortOptions.find((el) => el.id === val)?.value ?? undefined;
  }

  await router
    .replace({
      path: route.path,
      query: {
        ...route.query,
        sort_by: selectedSortValue,
      },
    })
    .catch(() => {});
  emit('on-sort-change');
});

watch(selectedFilterOptionId, async (val) => {
  await router
    .replace({
      path: route.path,
      query: {
        ...route.query,
        filter: val
          ? props.filterOptions.find((el) => el.id === val)?.value
          : undefined,
      },
    })
    .catch(() => {});
  emit('on-filter-change');
});

watch(selectedSourceOptionId, async (val) => {
  let selectedSourceValue;
  if (val === 0) {
    selectedSourceValue = undefined;
  } else {
    selectedSourceValue =
      props.sourcesList.find((el) => el.id === val)?.id ?? undefined;
  }

  await router
    .replace({
      path: route.path,
      query: {
        ...route.query,
        source: selectedSourceValue,
      },
    })
    .catch(() => {});
  emit('on-source-change');
});

watch(selectedCityId, async () => {
  await router.replace({
    path: route.path,
    query: { ...route.query },
  });
  emit('on-city-change', selectedCityId);
});

watch(startCenturyIndex, async (val) => {
  await router
    .replace({
      path: route.path,
      query: {
        ...route.query,
        ...(!props.isTimeline && { start_century_index: val }),
      },
    })
    .catch(() => {});

  emit('on-century-start-change');
});

watch(endCenturyIndex, async (newVal, preVal) => {
  await router
    .replace({
      path: route.path,
      query: {
        ...route.query,
        ...(!props.isTimeline && preVal !== 0 && { end_century_index: newVal }),
      },
    })
    .catch(() => {});

  emit('on-century-end-change');
});

/** methodts */

// const setRange = (start, end) => {
//   this.range.start = start;
//   this.range.end = end;
// };

const getDropdownFormattedData = (data) => {
  return data.map((el) => {
    return {
      id: el.id,
      label: el.label || el.title || el.name || el.text,
      disabled: el.disabled,
      counter: el.counter,
    };
  });
};

// const setSelectedYear = () => {
//   if (!this.$route.query?.start_year || !this.$route.query?.end_year) return;

//   this.sliderValue = {
//     start_year: +this.$route.query?.start_year,
//     end_year: +this.$route.query?.end_year,
//   };
// };

const handleResetFilters = () => {
  const query = Object.fromEntries(
    props.preservedQuery
      .filter((key) => key in route.query)
      .map((key) => [key, route.query[key]]),
  );
  router.replace({ path: route.path, query });
  emit('on-reset-filters');
};

const handleCenturySlider = (e) => {
  router.replace({
    path: route.path,
    query: {
      ...route.query,
      startCentury: e[0],
      endCentury: e[1],
    },
  });
};

const handleYearsSliderInteract = debounce((e) => {
  router
    .replace({
      path: route.path,
      query: {
        ...route.query,
        start_year: e[0],
        end_year: e[1],
      },
    })
    .catch(() => {});

  emit('on-century-change');
  emit('on-apply');
}, 400);

const getCenturyByIndex = (index) => {
  if (!props.centuriesList.length) {
    return index;
  }

  return props.centuriesList.find(({ id }) => index === id)?.label;
};
</script>
